module.exports = __webpack_public_path__ + "dd35bd1ce203ed90c5bac6aa90120af3.png";


//////////////////
// WEBPACK FOOTER
// ./web/images/logos/samsung.png
// module id = 644
// module chunks = 0